<template>
  <div style="height:100%;display:flex;align-items:center;">
    <Input :value="value" @on-change="onChange" @on-click="onClick" :icon="iosCall" />
  </div>
</template>

<script>
import minixBase64enDe from './minixBase64enDe.js'
export default {
  props: {
    allFieldsVal: Object,
    encryption: String,
    doubleCallFlag: Boolean,
    value: String
  },
  data() {
    return {
      iosCall: window.localStorage.getItem("returnCallId")?'ios-call':''
    }
  },
  methods: {
    onChange(e) {
      // console.log('Inputchange', e)
      this.$emit('on-change', e)
    },
    onClick() {
      // 为空不可打 新建不可打
      if(!this.value || !this.doubleCallFlag){
        return
      }
      let params={
          mtId: this.allFieldsVal.mt_id,
          encryption: this.encryption,
          called: this.encryption=='1'?minixBase64enDe.base64En(this.value,'1'):this.value,
          callerChangeVoice: '1',
          calledChangeVoice: '1',
          callerChangeVoiceLength: '+10',
          calledChangeVoiceLength: '+10'
        }
      this.$http
        .get('/scwf/doubleCall/call', {params})
        .then(({ data }) => {
          if (data.returnCode == 0) {
            this.$Message.success('双呼成功')
          }else{
            this.$Message.error(data.returnMessage)
          }
        })
        .catch(err => {
          console.error(err)
        })
    }
  }
}
</script>

<style>
</style>